import { useEffect, useState } from "react";

export function ProgressBar() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const update = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const pct = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
      setProgress(Math.min(100, Math.max(0, pct)));
    };

    window.addEventListener("scroll", update, { passive: true });
    update();
    return () => window.removeEventListener("scroll", update);
  }, []);

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[100] h-[2px] pointer-events-none"
      style={{ background: "rgba(0,0,0,0.0)" }}
    >
      <div
        style={{
          width: `${progress}%`,
          height: "100%",
          background:
            "linear-gradient(90deg, oklch(0.70 0.20 195), oklch(0.75 0.22 250), oklch(0.72 0.20 195))",
          boxShadow:
            "0 0 6px oklch(0.75 0.22 195 / 0.8), 0 0 14px oklch(0.70 0.20 195 / 0.4)",
          transition: "width 0.1s linear",
        }}
      />
    </div>
  );
}
